const ADMIN_BASE_URL = "/admin/site-visits";

export const FRONTEND = {
  CREATE: `${ADMIN_BASE_URL}/create`,
  VIEW: `${ADMIN_BASE_URL}/view`,
  SINGLE: `${ADMIN_BASE_URL}/:id`,
};
